import { render, staticRenderFns } from "./AdSpaceNew.vue?vue&type=template&id=561c48b5&scoped=true&"
import script from "./AdSpaceNew.vue?vue&type=script&lang=ts&"
export * from "./AdSpaceNew.vue?vue&type=script&lang=ts&"
import style0 from "./AdSpaceNew.vue?vue&type=style&index=0&id=561c48b5&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "561c48b5",
  null
  
)

export default component.exports